import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Container } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { SignUpSuccessClient, SignUpSuccessInvite, SignUpSuccessOperator } from "@/components/organisms/SignUp/contents";
import { useLayout } from "@/hooks";
import { Restricted } from "../Restricted/Restricted";

export const ProfileSignUpSuccess = () => {
  const [params] = useSearchParams();
  const paramsUserType = params.get("type");
  const { setFullScreen } = useLayout();
  const userTypes = ["client", "operator", "invite"];

  useEffect(() => {
    setFullScreen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSuccess = (userType: string) => {
    switch (userType) {
      case "operator":
        return <SignUpSuccessOperator />;
      case "invite":
        return <SignUpSuccessInvite />;
      default:
        return <SignUpSuccessClient />;
    }
  };

  const getAction = () => {
    if (paramsUserType && paramsUserType === "operator") return "contact";
    return undefined;
  };

  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action={getAction()} />
        {!paramsUserType || !userTypes.includes(paramsUserType) ? (
          <Restricted />
        ) : (
          <Container className="flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8 md:py-[100px]">
            {renderSuccess(paramsUserType)}
          </Container>
        )}
        <GeneralFooter />
      </div>
    </div>
  );
};
